<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24" style="padding:0 20px;">
        <MainTable :refreshCount="refreshCount" @editClick="(e)=>$emit('editClick',e)" @addBussiness="$emit('addBussiness')"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MainTable from "@/component/Business/main/mainTable/MainTable";
import ClueCountCard from "@/component/Business/main/visualChart/ClueCountCard";
import ClueTendcyCard from "@/component/Business/main/visualChart/ClueTendcyCard";
export default {
  name: "BusinessDetail",
  props:["refreshCount","resizeChartCount"],
  components:{
    MainTable,
    ClueCountCard,
    ClueTendcyCard
  },
  data(){
    return {
      clueInfo:null
    }
  },
  async mounted() {

  },

  watch:{

  },

  methods:{
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}


::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  //background-color: rgb(188, 188, 188);
  background-color:#E4E7F2;
  border-radius: 4px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>

